import React from 'react';
import type { IconProps } from '../types';

export const TabStudies = (props: IconProps) => (
  <svg
    width="22px"
    height="23px"
    viewBox="0 0 22 23"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>tab-studies</title>
    <g
      id="Artboards-Updated"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Segmentation---assets"
        transform="translate(-61, -242)"
      >
        <g
          id="tab-studies"
          transform="translate(61, 242.5)"
        >
          <rect
            id="Rectangle"
            x="0"
            y="0"
            width="22"
            height="22"
          ></rect>
          <path
            d="M6.93478261,15.0652174 L3.23913043,15.0652174 C2.83091997,15.0652174 2.5,14.7342974 2.5,14.326087 L2.5,3.23913043 C2.5,2.83091997 2.83091997,2.5 3.23913043,2.5 L14.326087,2.5 C14.7342974,2.5 15.0652174,2.83091997 15.0652174,3.23913043 L15.0652174,6.93478261"
            id="Path"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <rect
            id="Rectangle"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
            x="6.93478261"
            y="6.93478261"
            width="12.5652174"
            height="12.5652174"
            rx="1"
          ></rect>
        </g>
      </g>
    </g>
  </svg>
);

export default TabStudies;
